const convertJsonToCsv = (json, fileName) => {
    const keys = Object.keys(json[0]);

    const commaSeparatedString = [
        keys.join(","),
        json
            .map(row =>
                keys
                    .map(key => {
                        let colValue = row[key];

                        // fix for fields starting with 0 that are removed in excel
                        if (colValue && colValue.toString().startsWith("0")) {
                            colValue = "\t" + colValue;
                        }

                        colValue =
                            colValue && typeof colValue === "string"
                                ? `"${colValue.replace(/(\r\n|\n|\r)/gm, " ")}"`
                                : colValue;

                        return colValue;
                    })
                    .join(",")
            )
            .join("\n"),
    ].join("\n");

    var exportedFilenmae = fileName + ".csv" || "export.csv";

    var blob = new Blob([commaSeparatedString], {
        type: "text/csv;charset=utf-8;",
    });

    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};

export default convertJsonToCsv;
